import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=90b52d6e&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b52d6e",
  null
  
)

export default component.exports